// src/pages/Unsubscribe.jsx
import { useEffect, useState } from "react";
import { useSearchParams } from "react-router-dom";

export default function Unsubscribe() {
  const [searchParams] = useSearchParams();
  const [status, setStatus] = useState("loading");
  const [errorMessage, setErrorMessage] = useState("");

  useEffect(() => {
    const email = searchParams.get("email");
    const token = searchParams.get("token");
    const customerId = searchParams.get("customerId");
    const companyId = searchParams.get("companyId");

    // Validate required parameters
    if (!email || !token || !customerId || !companyId) {
      setStatus("error");
      setErrorMessage("Missing required parameters");
      return;
    }

    // Build URL with all parameters
    const url = new URL(`${process.env.REACT_APP_API_URL}/email/unsubscribe`);
    url.searchParams.append("email", email);
    url.searchParams.append("token", token);
    url.searchParams.append("customerId", customerId);
    url.searchParams.append("companyId", companyId);

    fetch(url.toString())
      .then((res) => {
        // Accept both 200 (success) and 304 (already unsubscribed/not modified)
        if (res.ok || res.status === 304) {
          setStatus("success");
        } else {
          // Try to parse error message from response
          return res.json().then(
            (data) => {
              setStatus("error");
              setErrorMessage(data.error || "Failed to unsubscribe");
            },
            () => {
              // If JSON parsing fails, use generic message
              setStatus("error");
              setErrorMessage(`Server error: ${res.status}`);
            },
          );
        }
      })
      .catch((error) => {
        setStatus("error");
        setErrorMessage("Network error. Please try again.");
        console.error("Unsubscribe error:", error);
      });
  }, [searchParams]);

  if (status === "loading") {
    return (
      <div
        style={{
          padding: "40px",
          textAlign: "center",
          fontFamily: "Arial, sans-serif",
        }}
      >
        <h2>Processing your request...</h2>
        <p style={{ color: "#666" }}>Please wait while we unsubscribe you.</p>
      </div>
    );
  }

  if (status === "success") {
    return (
      <div
        style={{
          padding: "40px",
          textAlign: "center",
          fontFamily: "Arial, sans-serif",
        }}
      >
        <h2 style={{ color: "#22c55e" }}>✓ Successfully Unsubscribed</h2>
        <p style={{ color: "#666", marginTop: "16px" }}>
          You've been unsubscribed from emails for this company.
        </p>
        <p style={{ color: "#666", fontSize: "14px", marginTop: "24px" }}>
          You won't receive any more emails about this specific company, but may
          still receive emails about other companies you've registered.
        </p>
      </div>
    );
  }

  return (
    <div
      style={{
        padding: "40px",
        textAlign: "center",
        fontFamily: "Arial, sans-serif",
      }}
    >
      <h2 style={{ color: "#ef4444" }}>Something Went Wrong</h2>
      <p style={{ color: "#666", marginTop: "16px" }}>
        {errorMessage || "Unable to process your unsubscribe request."}
      </p>
      <p style={{ color: "#666", fontSize: "14px", marginTop: "24px" }}>
        Please try again or contact support at{" "}
        <a href="mailto:hello@wizzyl.com" style={{ color: "#2563eb" }}>
          hello@wizzyl.com
        </a>
      </p>
    </div>
  );
}
